import { IController } from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ImCourseDiff } from 'Src/ng2/shared/services/im-models/im-course-diff';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { CsvExporterService } from '../../../../../../../../ng2/shared/services/csv-exporter/csv-exporter.service';
import { ICourseDiff } from '../../../../../../../../ng2/shared/typings/interfaces/course-diff.interface';
import { ISchool } from '../../../../../../../../ng2/shared/typings/interfaces/school.interface';
import { IStudent } from '../../../../../../../../ng2/shared/typings/interfaces/student.interface';
import { IWizardFilterActionsOptions } from '../../../../../components/wizard-filter-actions/wizard-filter-actions.typings';
import { SpinnerModal } from './../../../../../../../shared/modals/status-spinner/status-spinner.service';
import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class GenerateProgramChangesExportStepCtrl implements IController {
  static $inject: string[] = [
    '$scope',
    'ImSchool',
    'ObjectCache',
    'CsvExporter',
    'SpinnerModal',
    'CourseDiff',
    'Rollbar',
    'WizardUtils',
    'ImCourseDiff',
  ];

  public starsInstructions;
  public currentCourseDiffs;
  public currentTermYear;
  public school: ISchool;
  public sort: object;
  public plurals;
  public buckets;
  public courseDiffs: ICourseDiff[];
  public courseAdds: ICourseDiff[];
  public courseDrops: ICourseDiff[];
  public studentsWithPendingChangesForThisTerm: IStudent[];
  public studentsWithCreditGapPendingChanges: IStudent[];

  private currentStudents: IStudent[];
  public options: IWizardFilterActionsOptions;

  constructor(
    public $scope,
    private ImSchool: ImSchool,
    private ObjectCache: any,
    private CsvExporter: CsvExporterService,
    private SpinnerModal: SpinnerModal,
    private CourseDiff: any,
    private Rollbar,
    private WizardUtils: WizardUtils,
    private imCourseDiff: ImCourseDiff,
  ) {
    this.options = {
      columnKeys: ['gradPlan', 'creditMaxGaps', 'creditMaxGapsNoPlan'],
    };
  }

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  public setUi(): void {
    this.starsInstructions =
      'https://docs.google.com/document/d/1U3cKMJlpaXOOnGi5fZB2gZQa4XgukRnkCov1IIsM2qM/edit?usp=sharing';
    this.currentStudents = this.WizardUtils.getAllFlattenedStudents();
    this.school = this.WizardUtils.getCurrentSdcSchool();
    this.currentTermYear = this.ImSchool.getCurrentTermYear(this.school);
    this.buckets = this.generateFilteredStudentIdBuckets();
    this.courseDiffs = this.buckets.courseDiffs;

    this.studentsWithPendingChangesForThisTerm = _.uniq(this.buckets.studentsWithPendingChangesForThisTerm);
    const courseDiffFilter = {
      termYear: this.currentTermYear,
      status: 'PENDING',
    };
    this.courseAdds = this.imCourseDiff.filterForAddCourseDiffs(this.courseDiffs, courseDiffFilter);
    this.courseDrops = this.imCourseDiff.filterForDropCourseDiffs(this.courseDiffs, courseDiffFilter);
    this.plurals = {
      s: {
        0: 's',
        1: '',
        other: 's',
      },
    };
  }

  private generateFilteredStudentIdBuckets() {
    const unflattenedStudents = this.WizardUtils.getAllUnflattenedStudents();
    const courseDiffs = [];
    const studentsWithPendingChangesForThisTerm = [];
    _.each(this.currentStudents, (student: any) => {
      const unflattenedStudent = _.find(unflattenedStudents, { studentId: student.studentId });
      const { studentId, countOfCreditGapPendingChanges } = student;
      const { join_pendingCourseDiffs } = unflattenedStudent;
      _.each(join_pendingCourseDiffs, diff => {
        courseDiffs.push(diff);
      });
      const hasPendingChanges = countOfCreditGapPendingChanges > 0;
      if (hasPendingChanges) studentsWithPendingChangesForThisTerm.push(studentId);
    });
    return {
      courseDiffs,
      studentsWithPendingChangesForThisTerm,
    };
  }

  public generateCourseDiffCsv() {
    const docType = 'text/csv;charset=utf-8';
    this.SpinnerModal.activateSpinner('Generating Export');
    const termYear = this.currentTermYear;
    const currentDateAndTime = moment().format('MM-DD-YYYY hmma');
    const fileName = `STARS Course Upload ${termYear} ${currentDateAndTime}.csv`;
    const school = this.school;
    this.CsvExporter.createCourseDiffCsv(school)
      .then(csvString => {
        this.CsvExporter.exportCsv(csvString, fileName, docType);
        this.SpinnerModal.deactivateSpinner();
      })
      .catch(err => {
        this.SpinnerModal.deactivateSpinner();
        this.Rollbar.error(`Unable to complete CSV export`, err);
      });
  }
}
